/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type courses_RecordAttendanceRequest = {
    attendance_date: string;
    /**
     * BillingType override (optional). If not set, uses enrollment default.
     */
    billing_type?: courses_RecordAttendanceRequest.billing_type;
    child_id: string;
    comments?: string;
    course_plan_id: string;
    enrollment_id?: string;
    status: courses_RecordAttendanceRequest.status;
};
export namespace courses_RecordAttendanceRequest {
    /**
     * BillingType override (optional). If not set, uses enrollment default.
     */
    export enum billing_type {
        PER_MONTH = 'per_month',
        PER_UNIT = 'per_unit',
        FREE = 'free',
    }
    export enum status {
        PENDING = 'pending',
        APPROVED = 'approved',
        CANCELLED = 'cancelled',
    }
}

